import { Grid, Paper, Box, Typography, Button, Tabs, Tab, Snackbar, Alert } from "@mui/material";
import React, { useState } from "react";
import "../../Styles/strategy.css";
import UserStatusTable from "../Tables/UserStatusTable";
import HouseholdInvestorsTable from "../Tables/HouseholdInvestorsTable";
import CreateHouseholdModal from "../../Modals/CreateHouseholdModal";
import { useDispatch } from "react-redux";
import { GetHouseholds } from "../../redux/Actions/userStatusService";

function UserStatus() {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  const [openCreateHouseholdModal, setOpenCreateHouseholdModal] = useState(false);
  const [isHouseholdDetailsView, setIsHouseholdDetailsView] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    // When switching tabs, ensure we exit any household details view
    if (newValue !== 1 && isHouseholdDetailsView) {
      setIsHouseholdDetailsView(false);
    }
  };

  const handleCreateHousehold = () => {
    setOpenCreateHouseholdModal(true);
  };

  const handleCloseCreateHouseholdModal = () => {
    setOpenCreateHouseholdModal(false);
  };

  const handleHouseholdCreateResult = (result) => {
    if (!result) return;

    if (result.success) {
      setSnackbar({
        open: true,
        message: result.message || "Household created successfully",
        severity: "success",
      });
      // Refresh households list so main table shows new record
      dispatch(GetHouseholds());
    } else {
      setSnackbar({
        open: true,
        message: result.message || "Something went wrong while creating household.",
        severity: "error",
      });
    }
  };

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleShowSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  return (
    <>
      {/* Header Section with Title and Button - Outside Card */}
      {!isHouseholdDetailsView && (
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              mb: 3
            }}
          >
            <Box>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 600,
                  color: "#000",
                  mb: 1,
                  fontSize: "28px"
                }}
              >
                Investor Management
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#6B7280",
                  fontSize: "14px"
                }}
              >
               View and manage investor and household details
              </Typography>
            </Box>
            <Button
              variant="contained"
              onClick={handleCreateHousehold}
              sx={{
                backgroundColor: "#2563EB",
                color: "#fff",
                textTransform: "none",
                fontSize: "14px",
                fontWeight: 600,
                px: 3,
                py: 1.5,
                borderRadius: "4px",
                boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                "&:hover": {
                  backgroundColor: "#1d4ed8",
                }
              }}
            >
              Create a Household
            </Button>
          </Box>
        </Grid>
      )}

      {/* Tabs Section - Inside Card */}
      {!isHouseholdDetailsView && (
        <Grid item xs={12}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              borderRadius: 2,
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)"
            }}
            elevation={0}
          >
            <Box sx={{ borderBottom: 1, borderColor: "divider", px: 3 }}>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                sx={{
                  "& .MuiTab-root": {
                    textTransform: "none",
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "#6B7280",
                    minWidth: "auto",
                    px: 0,
                    mr: 4,
                    py: 2,
                    "&.Mui-selected": {
                      color: "#2563EB",
                      fontWeight: 600
                    }
                  },
                  "& .MuiTabs-indicator": {
                    backgroundColor: "#2563EB",
                    height: 3
                  }
                }}
              >
                <Tab label="Custodian-wise Investors" />
                <Tab label="Household-wise Investors" />
              </Tabs>
            </Box>
          </Paper>
        </Grid>
      )}

      {/* Content Section */}
      <Grid item xs={12}>
        <Box sx={{ mt: isHouseholdDetailsView ? 0 : 2 }}>
          {activeTab === 0 && <UserStatusTable />}
          {activeTab === 1 && (
            <HouseholdInvestorsTable
              onDetailsChange={setIsHouseholdDetailsView}
              onShowSnackbar={handleShowSnackbar}
            />
          )}
        </Box>
      </Grid>

      {/* Create Household Modal */}
      <CreateHouseholdModal 
        open={openCreateHouseholdModal} 
        onClose={handleCloseCreateHouseholdModal}
        onCreateResult={handleHouseholdCreateResult}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default UserStatus;
